import React from "react";
import "./ToggleSwitch.css";

interface ToggleSwitchProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  trueLabel?: string;
  falseLabel?: string;
  width?: string;
  bothEnabledLabels?: boolean;
  topMargin?: string;
  disabled?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  label,
  description,
  checked,
  width,
  onChange,
  disabled,
  trueLabel = "Allow",
  falseLabel = "Deny",
  bothEnabledLabels = false,
  topMargin = "12px"
}) => {
  return (
    <div className="toggle-container" style={{marginTop: topMargin, opacity: disabled? 0.6 : 1, pointerEvents: disabled ? 'none' : 'auto'}}>
      <div>
        <div className="toggle-label">{label}</div>
        {description && <div className="toggle-description">{description}</div>}
      </div>

      <div
        style={{width: width || "60px"}}
        className={`toggle-switch ${checked || bothEnabledLabels ? "checked" : "unchecked"}`}
        onClick={() => onChange(!checked)}
      >
        <span
          className={`toggle-text ${checked ? "left" : "right"}`}
        >
          {checked ? trueLabel : falseLabel}
        </span>
        <div
          className={`toggle-knob ${checked ? "checked" : "unchecked"}`}
        />
      </div>
    </div>
  );
};

export default ToggleSwitch;